import { FC, memo, useContext } from 'react'

import { Container, ReviewsWrapper, SliderContainer } from './styles'
import { useTranslation } from '../../../hooks/locale'
import ListingSectionTransport from '../../../transports/common/listing-section-transport'
import { Subtitle, Title, TitleContainer } from '../common/styles'
import ReviewsCard from '../../common/reviews-card'
import { ScreenContext } from 'react-components'
import { BreadcrumbListTransport } from '../../../models/common/breadcrumb-model'
import { cardEventCategories, pageTypeEventCategories } from '../../../services/analytics-service/categories'
import { EmblaCarousel } from '../../common/embla-carousel'

interface Props {
    topRatedObjectsSection: ListingSectionTransport
    breadcrumbList?: BreadcrumbListTransport
}

const ReviewsSection: FC<Props> = ({ topRatedObjectsSection, breadcrumbList }) => {
    const { heading, objects: reviewObjects } = topRatedObjectsSection
    const { t } = useTranslation()
    const { isTablet, isDesktop } = useContext(ScreenContext)

    return (
        <Container id="reviews">
            <TitleContainer>
                <Title>{heading}</Title>
                <Subtitle>{t('reviewsSubTitle')}</Subtitle>
            </TitleContainer>

            {isDesktop ? (
                <ReviewsWrapper>
                    {reviewObjects.map((item, index) => (
                        <ReviewsCard
                            key={`review-card-${index}`}
                            position={index}
                            listing={item}
                            breadcrumbList={breadcrumbList}
                            pageName={pageTypeEventCategories.REGION_LANDING_PAGE}
                            sectionName={cardEventCategories.sections.REVIEW}
                        />
                    ))}
                </ReviewsWrapper>
            ) : (
                <SliderContainer>
                    <EmblaCarousel
                        slides={reviewObjects.map((reviewObject, index) => (
                            <ReviewsCard
                                key={reviewObject.id}
                                listing={reviewObject}
                                position={index}
                                breadcrumbList={breadcrumbList}
                                pageName={pageTypeEventCategories.REGION_LANDING_PAGE}
                                sectionName={cardEventCategories.sections.REVIEW}
                            />
                        ))}
                        visibleSlides={isTablet ? 1.75 : 1.1}
                        slidesToScroll={1}
                    />
                </SliderContainer>
            )}
        </Container>
    )
}

export default memo(ReviewsSection)
